import { reactive } from "vue";

export function useModal() {
  const bClick = () => {
    console.log(112);
  }
  return {
    bClick
  }
};
